var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoadmapIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_867_370)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 9.45312V3.59375C40 1.65523 38.4229 0.078125 36.4844 0.078125H3.51562C1.57711 0.078125 0 1.65523 0 3.59375V9.45312H40ZM27.0312 4.76562H34.0625C34.7097 4.76562 35.2344 5.29031 35.2344 5.9375C35.2344 6.58469 34.7097 7.10938 34.0625 7.10938H27.0312C26.3841 7.10938 25.8594 6.58469 25.8594 5.9375C25.8594 5.29031 26.3841 4.76562 27.0312 4.76562ZM15.3125 4.76562C15.9597 4.76562 16.4844 5.29031 16.4844 5.9375C16.4844 6.58469 15.9597 7.10938 15.3125 7.10938C14.6653 7.10938 14.1406 6.58469 14.1406 5.9375C14.1406 5.29031 14.6653 4.76562 15.3125 4.76562ZM10.625 4.76562C11.2722 4.76562 11.7969 5.29031 11.7969 5.9375C11.7969 6.58469 11.2722 7.10938 10.625 7.10938C9.97781 7.10938 9.45312 6.58469 9.45312 5.9375C9.45312 5.29031 9.97781 4.76562 10.625 4.76562ZM5.9375 4.76562C6.58469 4.76562 7.10938 5.29031 7.10938 5.9375C7.10938 6.58469 6.58469 7.10938 5.9375 7.10938C5.29031 7.10938 4.76562 6.58469 4.76562 5.9375C4.76562 5.29031 5.29031 4.76562 5.9375 4.76562ZM0 11.7969V36.4062C0 38.3448 1.57711 39.9219 3.51562 39.9219H36.4844C38.4229 39.9219 40 38.3448 40 36.4062V11.7969H0ZM13.7008 28.4599C14.2062 28.8642 14.2881 29.6016 13.8838 30.107C13.4796 30.6123 12.742 30.6944 12.2367 30.29L6.37734 25.6025C5.79148 25.134 5.79109 24.2413 6.37734 23.7723L12.2367 19.0848C12.7419 18.6805 13.4795 18.7624 13.8838 19.2678C14.2881 19.7732 14.2062 20.5107 13.7008 20.9149L8.98531 24.6875L13.7008 28.4599ZM24.5927 16.946L17.5615 33.3523C17.3066 33.947 16.6178 34.2228 16.0227 33.9677C15.4279 33.7128 15.1523 33.0238 15.4073 32.429L22.4385 16.0227C22.6935 15.4279 23.3824 15.1523 23.9773 15.4073C24.5721 15.6622 24.8477 16.3511 24.5927 16.946ZM33.6227 25.6026L27.7633 30.2901C27.2587 30.6938 26.5211 30.6132 26.1162 30.1071C25.7119 29.6017 25.7938 28.8642 26.2992 28.46L31.0147 24.6875L26.2992 20.9151C25.7938 20.5108 25.7119 19.7734 26.1162 19.268C26.5204 18.7626 27.2579 18.6806 27.7633 19.085L33.6227 23.7725C34.2085 24.241 34.2089 25.1337 33.6227 25.6026Z",
    fill: "url(#paint0_linear_867_370)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_867_370",
    x1: 40,
    y1: 20,
    x2: 0,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2D138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37A058"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_867_370"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadmapIcon1);
export default __webpack_public_path__ + "static/media/roadmap-icon-1.fc53eac2869fb6b7272baedfa2aefbb2.svg";
export { ForwardRef as ReactComponent };